import { GET_TRAINING_CATEGORIES } from '@/api/training-categories/training-categories';

export default {
  namespaced: true,
  state: {
    trainingCategories: [],
    loading: false,
    error: null
  },
  mutations: {
    SET_TRAINING_CATEGORIES(state, data) {
      state.trainingCategories = data;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    }
  },
  actions: {
    async fetchTrainingCategories({ commit }, params) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      try {
        const response = await GET_TRAINING_CATEGORIES(params);
        if (response.data && response.data.data && response.data.data.data) {
          commit('SET_TRAINING_CATEGORIES', response.data.data.data);
        }
        commit('SET_LOADING', false);
        return response.data;
      } catch (error) {
        commit('SET_ERROR', error);
        commit('SET_LOADING', false);
        throw error;
      }
    }
  }
}
